import classNames from 'classnames';
import { observer } from 'mobx-react';

import ObsoleteConfigurationModal from '../../../../../configurator/components/ObsoleteConfigurationModal/ObsoleteConfigurationModal';
import OptionDescriptionModal from '../../../../../configurator/components/OptionDescriptionModal/OptionDescriptionModal';
import ResolveRestrictionsModal from '../../../../../configurator/components/ResolveRestrictionsModal/ResolveRestrictionsModal';
import NavButton from '../../../../../shared/components/Button/NavButton';
import Icon from '../../../../../shared/components/Icon/Icon';
import Heading, { HeadingSize } from '../../../../../shared/components/Typography/Heading/Heading';
import ModularComponentConfiguratorTabs from '../../ModularComponentConfigurator/ModularComponentConfiguratorTabs/ModularComponentConfiguratorTabs';
import ModularConfiguratorCoordinatorState from '../../ModularConfiguratorCoordinatorState';
import css from './ModularComponentConfigurator.css';

interface ModularComponentConfiguratorProps {
  state: ModularConfiguratorCoordinatorState;
}

const ModularComponentConfigurator = observer(({ state }: ModularComponentConfiguratorProps) => {
  const selectedComponent = state.configurator.selectedComponent;
  const isComponentSelected = !!selectedComponent;
  const configuratorState = selectedComponent ?? state.configurator.defaultComponentConfigurator;

  if (!configuratorState) {
    return null;
  }

  return (
    <>
      <ObsoleteConfigurationModal
        modal={configuratorState.coreState.obsoleteConfigurationModal}
        translation={configuratorState.coreState.translation.obsoleteCodeModal}
      />
      <ResolveRestrictionsModal
        modal={configuratorState.coreState.restrictionsModal}
        translation={configuratorState.coreState.translation.restrictions}
      />
      <OptionDescriptionModal
        modal={configuratorState.coreState.optionDescriptionModal}
        translation={configuratorState.coreState.translation.optionDescriptionModal}
      />

      <section className={css.container}>
        <NavButton className={css.backButton} onClick={state.setLayoutMode} back>
          All layouts
        </NavButton>
        <Heading level={2} className={css.heading} size={HeadingSize.Medium}>
          Edit module details
        </Heading>
        <div className={css.contentContainer}>
          <div className={classNames(css.content, { [css.disabled]: !isComponentSelected })}>
            {state.configurator.isConfigureActionActive ? (
              <ModularComponentConfiguratorTabs state={configuratorState.coreState.tabs} />
            ) : state.configurator.isMoveActionActive ? (
              <div className={css.inner}>
                position x ={' '}
                <input
                  type="number"
                  step="0.1"
                  value={configuratorState.sceneObjectsGroup.position.x}
                  onChange={(e) => configuratorState.sceneObjectsGroup.setPosition({ x: parseFloat(e.target.value) })}
                />
                <br />
                position y ={' '}
                <input
                  type="number"
                  step="0.1"
                  value={configuratorState.sceneObjectsGroup.position.y}
                  onChange={(e) => configuratorState.sceneObjectsGroup.setPosition({ y: parseFloat(e.target.value) })}
                />
                <br />
                position z ={' '}
                <input
                  step="0.1"
                  type="number"
                  value={configuratorState.sceneObjectsGroup.position.z}
                  onChange={(e) => configuratorState.sceneObjectsGroup.setPosition({ z: parseFloat(e.target.value) })}
                />
                <br />
              </div>
            ) : (
              <div className={css.inner}>
                rotation x ={' '}
                <input
                  type="number"
                  step="0.1"
                  value={configuratorState.sceneObjectsGroup.rotation.x}
                  onChange={(e) => configuratorState.sceneObjectsGroup.setRotation({ x: parseFloat(e.target.value) })}
                />
                <br />
                rotation y ={' '}
                <input
                  type="number"
                  step="0.1"
                  value={configuratorState.sceneObjectsGroup.rotation.y}
                  onChange={(e) => configuratorState.sceneObjectsGroup.setRotation({ y: parseFloat(e.target.value) })}
                />
                <br />
                rotation z ={' '}
                <input
                  type="number"
                  step="0.1"
                  value={configuratorState.sceneObjectsGroup.rotation.z}
                  onChange={(e) => configuratorState.sceneObjectsGroup.setRotation({ z: parseFloat(e.target.value) })}
                />
                <br />
              </div>
            )}
          </div>
          {!isComponentSelected && (
            <div className={css.hint}>
              <Icon name="click" className={css.icon} /> Click any module in the layout on the right to edit its style.
            </div>
          )}
        </div>
      </section>
    </>
  );
});

export default ModularComponentConfigurator;
